
import { FactProcess } from "../types";

/**
 * Service to handle file generation and downloads for electronic filing.
 */
export const ExportService = {
  
  downloadTranscript(process: FactProcess) {
    const header = `LLUIS LAW APC - CONFIDENTIAL TRANSCRIPT\nClient: ${process.client.name}\nDate: ${new Date().toLocaleDateString()}\nCase Type: ${process.type}\n----------------------------------------\n\n`;
    
    const body = process.transcript.map(t => 
      `[${new Date(t.timestamp).toLocaleTimeString()}] ${t.role === 'AI' ? 'ATTORNEY (AI)' : 'CLIENT'}: ${t.text}`
    ).join('\n\n');

    const content = header + body;
    this.triggerDownload(content, `${process.client.name.replace(/\s+/g, '_')}_Transcript.txt`, 'text/plain');
  },

  downloadDraft(process: FactProcess) {
    if (!process.draftedDeclaration) return;
    
    const content = process.draftedDeclaration;
    // In a real app, we might generate a .docx blob here
    this.triggerDownload(content, `${process.client.name.replace(/\s+/g, '_')}_Declaration_Draft.md`, 'text/markdown');
  },

  downloadMatterLog(processes: FactProcess[]) {
    if (processes.length === 0) {
      alert("No matters available to export.");
      return;
    }

    const headers = ["Client Name", "Case Type", "Phone", "Email", "Appointment", "Status", "Created At"];
    const rows = processes.map(p => [
      `"${p.client.name.replace(/"/g, '""')}"`,
      `"${p.type}"`,
      `"${p.client.phone}"`,
      `"${p.client.email}"`,
      `"${new Date(p.appointment.dateTime).toLocaleString()}"`,
      `"${p.status}"`,
      `"${new Date(p.createdAt).toLocaleDateString()}"`
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map(r => r.join(","))
    ].join("\n");

    const filename = `FactGather_MatterLog_${new Date().toISOString().split('T')[0]}.csv`;
    this.triggerDownload(csvContent, filename, 'text/csv');
  },

  triggerDownload(content: string, filename: string, mimeType: string) {
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
};
